export default {
  phoneNineDigits: { blocks: [0, 2, 5, 4], delimiters: ['(', ') ', '-'], numericOnly: true },
  cpf: { blocks: [3, 3, 3, 3], delimiters: ['.', '.', '-'], numericOnly: true },
  cnpj: { blocks: [2, 3, 3, 4, 2], delimiters: ['.', '.', '/', '-'], numericOnly: true },
  mmYY: '00/00',
  creditCard: '0000 0000 0000 0000',
};
